import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import fromPairs from 'lodash/fromPairs';
import {
  PLACEHOLDER_OPT,
} from '../Forms/Schemas/baseRrf';
import { addNotification } from '../../actions/notifications';
import { createUserUpload } from '../../actions/user';

import UploadVerifyDocs from './UploadVerifyDocs';

const INITIAL_FILENAME = 'No file selected';
const MAX_UPLOAD_SIZE = 10485760;
const MAX_UPLOAD_SIZE_MB = 10;
const FINRA_MEMBER_FORM = 'FINRA_MEMBER_FORM';
const CIP_VERIFICATION = 'CIP_VERIFICATION';
const UPLOAD_TYPE = 0; // FINRA DOCUMENT UPLOAD TYPE


class UploadVerifyDocsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isComplete: false,
      fileForUpload: undefined,
      fileName: INITIAL_FILENAME,
      fileErrors: [],
    };
  }
  onSubmit = async () => {
    const {
      fileForUpload,
      fileErrors,
    } = this.state;
    if (!fileErrors || fileErrors.length === 0) {
      this.setState({
        isLoading: true,
        isComplete: false,
      });
      try {
        const {
          selectedDocType,
        } = this.props;
        await this.props.createUserUpload(
          fileForUpload,
          selectedDocType,
          UPLOAD_TYPE,
        );
        this.setState({
          fileForUpload: null,
          isLoading: false,
          isComplete: true,
        });
      } catch (err) {
        if (err.res) {
          const { error } = await err.res.json();
          switch (error.message) {
            case 'request entity too large':
              this.props.addNotification('The selected file is too large.');
              break;
            default:
              this.props.addNotification(`Error response from server: ${
                (error && error.validationErrors &&
                  JSON.stringify(error.validationErrors, null, 2)) ||
                  err.message ||
                  error.message}`);
              break;
          }
        } else {
          this.props.addNotification('Unknown error');
        }
        this.setState({
          isLoading: false,
          isComplete: false,
        });
      }
    }
  }
  onDrop = (acceptedFiles) => {
    if (acceptedFiles[0]) {
      const file = acceptedFiles[0];
      const fileErrors = this.validateFile(file);

      if (fileErrors.length === 0) {
        const reader = new FileReader();
        reader.onload = () => {
          const fileAsB64 = window.btoa(reader.result);
          this.setState({
            isLoading: false,
            fileForUpload: fileAsB64,
          });
        };
        reader.onabort = () => {
          this.setState({
            isLoading: false,
            fileName: INITIAL_FILENAME,
            fileErrors: ['Loading file cancelled.'],
          });
        };
        reader.onerror = () => {
          this.setState({
            isLoading: false,
            fileName: INITIAL_FILENAME,
            fileErrors: ['Unable to read selected file.'],
          });
        };

        reader.readAsBinaryString(file);
      }

      this.setState({
        isLoading: fileErrors && fileErrors.length === 0,
        fileName: file.name,
        fileErrors: fileErrors.length > 0 ? fileErrors : null,
      });
    } else {
      this.props.addNotification('File not found.');
      this.setState({
        fileName: INITIAL_FILENAME,
      });
    }
  }
  validateFile = (file) => {
    const fileErrors = [];
    if (file.size > MAX_UPLOAD_SIZE) {
      fileErrors.push(`File must be smaller than ${MAX_UPLOAD_SIZE_MB} MB.`);
    }

    if (this.props.selectedDocType !== CIP_VERIFICATION &&
      (!file.name.toLowerCase().endsWith('.pdf'))) {
      fileErrors.push('File must be a .pdf.');
    }

    if (this.props.selectedDocType === CIP_VERIFICATION &&
      (!file.name.toLowerCase().endsWith('.pdf')
        && !file.name.toLowerCase().endsWith('.jpg')
        && !file.name.toLowerCase().endsWith('.png'))) {
      fileErrors.push('File must be a .jpg, .png, or .pdf.');
    }
    return fileErrors;
  }
  render() {
    const {
      accountRestrictions,
      selectedDocType,
      accountNumber,
    } = this.props;
    const {
      fileName,
      fileErrors,
      isLoading,
      isComplete,
    } = this.state;
    const showDropzone = selectedDocType !== PLACEHOLDER_OPT;
    const docOpts = [[PLACEHOLDER_OPT, 'Select document type']];
    accountRestrictions.forEach((restrict) => {
      const name = get(restrict, 'reason.name', '');
      if (name.toLowerCase() === 'industry affiliation') {
        docOpts.push([FINRA_MEMBER_FORM, 'FINRA Member Approval Form']);
      }
      if (name.toLowerCase() === 'cip failure') {
        docOpts.push([CIP_VERIFICATION, 'Image of government issued ID']);
      }
    });
    const docTypeOptions = fromPairs(docOpts);
    const instructions = selectedDocType === CIP_VERIFICATION ?
      'Drag .pdf, .jpg, or .png file into box or click box to select file for upload.'
      : 'Drag .pdf file into box or click box to select file for upload.';
    return (
      <UploadVerifyDocs
        onSubmit={this.onSubmit}
        docTypeOptions={docTypeOptions}
        fileName={fileName}
        fileErrors={fileErrors}
        onDrop={this.onDrop}
        showDropzone={showDropzone}
        instructions={instructions}
        isLoading={isLoading}
        isComplete={isComplete}
        accountNumber={accountNumber}
      />
    );
  }
}

const mapStateToProps = (state, { match: { params: { userId } } }) => ({
  accountNumber: state.currentAccount,
  userId,
  accountRestrictions: get(state, `accountRestrictionsByAccount.[${state.currentAccount}].data`, []),
  selectedDocType: get(state, 'uploadVerifyDocsForm.verifyDocs.type', ''),
});

const mapDispatchToProps = {
  createUserUpload,
  addNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadVerifyDocsContainer);



// WEBPACK FOOTER //
// ./src/components/UploadVerifyDocs/index.js